<template>
  <header id="header" class="py-3">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-auto me-auto">
          <img src="../assets/images/logo-3.svg" alt="logo">
        </div>
        <div class="col-auto">
          <img src="../assets/images/user-2.svg" alt="icon">
        </div>
      </div>
    </div>
  </header>

  <div class="main-height">
    <section class="change-password">
      <div class="container">
        <div class="inner-container">
          <div class="row card bg-light border-0 rounded-4 p-sm-5 p-4 pt-6">
            <div class="col-12">
              <div class="fw-bold">
                <h2 class="fw-bold mb-4 text-center">Android update!</h2>
              </div>

              <!-- Conditional message block -->
              <h4 v-if="androidAppAction === 'delete'" class="mb-4 text-center">
                Sorry for the inconvenience. Due to an error on our side, this version of the app no longer functions properly and needs to be deleted.
                Please download the latest version using the link below.
              </h4>

              <h4 v-else-if="androidAppAction === 'update'" class="mb-4 text-center">
                New version is available.<br>Click here to download now!
              </h4>

              <h4 v-else class="mb-4 text-center text-muted">
                No Android update information available.
              </h4>

              <!-- Button -->
              <div>
                <button
                    class="btn btn-primary w-100 mt-3 rounded-0"
                    @click="doSubmit"
                    :disabled="loading"
                    id="btn"
                >
                  <span v-show="!loading">Update</span>
                  <span
                      v-show="loading"
                      class="spinner-grow spinner-grow-sm"
                      style="width: 0.8rem; height: 0.8rem;"
                      role="status"
                      aria-hidden="true"
                  ></span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <Footer></Footer>
</template>

<script>
import {defineComponent} from 'vue'
import Footer from "@/components/Footer.vue";

export default defineComponent({
  name: "AndroidUpdateNotification",
  components : {
    Footer
  },
  data() {
    return {
      loading: false,
      androidAppAction: null
    }
  },
  mounted() {
    const action = localStorage.getItem('androidAppAction');
    if (!action) {
      this.$router.push('/events');
    }
    this.androidAppAction = action === 'delete' || action === 'update' ? action : 'unknown';
  },
  methods: {

    doSubmit: function () {
      const systemData = localStorage.getItem('systemData');
      if (systemData) {
        const updateUrl = JSON.parse(systemData).value;
        window.open(updateUrl)
      }
    }
  }

})
</script>

<style>
@import '../assets/style.css';
#btn{background: linear-gradient(90deg, rgba(30,208,214,1) 0%, rgba(0,80,166,1) 100%); min-height: 74px;}
</style>
